import { imageBaseURL } from "../../../data/createBotForm";
import React from "react";
import { useRouter } from 'next/router'
import styles from "../../../styles/pages/botStore.module.scss";


function index(props) {


  const router = useRouter()

  const [currentBot, setCurrentBot] = React.useState(null)





  React.useEffect(() => {
    setCurrentBot(props.currentBot)
  }, [props.currentBot])



  React.useEffect(() => {
    //console.log(router.query, "all kinda queries")
  }, [router.query])



  return (
    <div>
       <div className="container h-100">
        <div className="row  mt-5 pt-5">
            <div className="col-md-6 col-12">
                <div className={styles.crard_main_section}>
                    <div className="d-flex align-items-center mb-2 pb-1">
                    <img src={`${imageBaseURL}product01.svg`} alt=""  className="mr-2"/><h1 style={{fontWeight:"600"}}>Coupa PO Creation</h1>
                    </div>
                    <div className={styles.card_section1}>
                        <div className="mb-2">
                            <img src={`${imageBaseURL}maps.svg`} alt="" className="mr-2" />
                            <span>Clusters Live</span>
                        </div>
                        <p>Europe(Poland, Romania)</p>
                    </div>
                    <p className="crard_main_section_p">We can help you automate PO Creation with Coupa for a faster & efficient solution</p>
                </div>
                <div className={styles.blue_card_section}>  
                    <div className="d-flex justify-content-center">
                        <div className="d-flex align-items-center justify-content-center">
                            <h1 className="align-self-center mr-4">1400+</h1>
                            <p className="align-self-center">Manual hours saved per country</p>
                        </div>
                        {/* <div className=" col-6" >
                            <h1>1400+</h1>
                            <p>hrs/annum saved</p>
                        </div>
                        <div className="col-6 " >
                            <p>Manual time saved</p>
                        </div>
                  </div> 
                </div>
            </div>
            <div className="col-md-6 col-12 align-self-end">
                 <div className={styles.iframe_section} dangerouslySetInnerHTML={{ __html: `<iframe src=${imageBaseURL}cupa.mp4 />`}} />
            </div>
        </div>
       </div>
       <div className={styles.benefits_section}>
            <div className="container h-100">
                <div  className="mb-5">
                <h1>Top Benefits</h1>
                </div>
                <div className={styles.Frist_section}>
                <div className="row ">
                    <div className="col-md-3 col-6  mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}benifits.svg`} alt="" />
                            <p>Scalable & customizable solution</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}benifits1.svg`} alt="" />
                            <p>Process optimization and faster PO creation</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}benifits2.svg`} alt="" />
                            <p>Centralized order tracking </p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}benifits3.svg`} alt="" />
                            <p>Data accuracy and compliance</p>
                        </div>
                    </div>
                </div>
                </div>
                <div className="row">
                    <div className="col-md-6 text-center">
                    <div  className={`text-center position-relative ${styles.cards_benefits_card}`}>
                         <img src={`${imageBaseURL}robo.png`} alt="" />
                            <div className="back_image">
                                <img src={`${imageBaseURL}dot.svg`} className={styles.img_1} alt="" />
                                <img src={`${imageBaseURL}dot1.svg`} className={styles.img_2} alt="" />
                                <img src={`${imageBaseURL}dot2.svg`} className={styles.img_3} alt="" />

                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h2 className="mb-5" style={{fontWeight:"600"}}>Process</h2>
                        {/* <p className="mb-4">1,000s of invoices left to be updated! Don’t worry, we can help your team colate & update invoices on your behalf.</p> */}
                        <ol>
                            <li >
                                <div>
                                    <p> Business places creation requests in Sharepoint</p>
                                </div>
                            </li>
                            <li >
                                    <div>
                                        <p>
                                        Bot runs on agreed schedules
                                        </p>
                                    </div>
                                </li>
                            <li >
                                    <div>
                                        <p>
                                        Picks pending requests
                                        </p>
                                    </div>
                                </li>
                            <li >
                                <div>
                                    <p>Send PR requests details & attachments to Mule API</p>
                                </div>
                            </li>
                            <li >
                                <div>
                                    <p>Approver to review & approve requests</p>
                                </div>
                            </li>
                            <li >
                                <div>
                                    <p>Send PO pending requests to Mule API</p>
                                </div>
                            </li>
                            <li >
                                <div>
                                    <p>Acknowledge users about completion</p>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  );
}

export default index;

